import React, { useState } from 'react';
import {
    TextField,
    Button,
    Container,
    Grid,
    Typography,
    Box,
    Paper,
    ThemeProvider,
    createTheme,
    IconButton,
    Popover,
    Input,
} from '@mui/material';
import {
    Business,
    Email,
    Phone,
    Language,
    Description,
    Palette,
} from '@mui/icons-material';
import NumbersIcon from '@mui/icons-material/Numbers';
import HomeIcon from '@mui/icons-material/Home';

import { useAuth } from '../../Auth/AuthProvider';
import { empresaCreate } from '../../Conections/EmpresaConection';
import { useNavigate } from 'react-router-dom';
import { can } from '../../Conections/LogConections';

const theme = createTheme({
    palette: {
        primary: {
            main: '#1976d2',
        },
        secondary: {
            main: '#dc004e',
        },
        background: {
            default: '#f5f5f5',
        },
    },
});

const ColorPicker = ({ color, onChange }) => {

    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'color-popover' : undefined;

    const colors = ['#0000FF',
        '#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A',
        '#98D8C8', '#F06292', '#AED581', '#7986CB',
        '#4DB6AC', '#9575CD', '#FFB74D', '#A1887F'
    ];

    return (
        <Box>
            <Button
                aria-describedby={id}
                variant="outlined"
                onClick={handleClick}
                startIcon={<Palette />}
                style={{ backgroundColor: color, color: 'white' }}
            >
                {color}
            </Button>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <Box p={2}>
                    <Grid container spacing={1}>
                        {colors.map((c) => (
                            <Grid item key={c}>
                                <IconButton
                                    style={{ backgroundColor: c }}
                                    onClick={() => {
                                        onChange(c);
                                        handleClose();
                                    }}
                                >
                                    <Box style={{ width: 20, height: 20 }} />
                                </IconButton>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </Popover>
        </Box>
    );
};

export default function CompanyForm() {
    
    const goTo = useNavigate();
    const { getToken, getCompany } = useAuth();

    React.useEffect(() => {
        reloaduser();
    }, []);

    async function reloaduser() {
        if (getToken()) {
            const permisionCan = await can(getToken(), getCompany(), "/dashboard/com/createcompany");
            if (!permisionCan) {
                goTo("/dashboard");
            }
        }
        else {
            goTo("/login");
        }
    }

    const [formData, setFormData] = useState({
        name: '',
        address: '',
        phone: '',
        nit: '',
        email: '',
        website: '',
        description: '',
        color: '#0000FF'
    });
    const [file, setFile] = React.useState('');

    const convertImagen = async (e) => {
        const logoC = await convertBase64(e.target.files[0]);
        const logo = logoC.split(',');
        setFile(logo[1]);
    };

    const convertBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = () => {
                resolve(fileReader.result)
            };
            fileReader.onerror = (error) => {
                reject(error);
            };
        });
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleColorChange = (color) => {
        setFormData(prevData => ({
            ...prevData,
            color: color
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const datos = await empresaCreate(
            getToken(),
            getCompany(),
            formData.name,
            formData.address,
            formData.phone,
            formData.nit,
            formData.email,
            formData.website,
            formData.description,
            formData.color,
            file
        );
        goTo(`/dashboard/com/showcompany/${datos}`);
    };

    return (
        <ThemeProvider theme={theme}>
            <Box
                sx={{
                    // minHeight: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    bgcolor: 'background.default',
                    py: 4,
                }}
            >
                <Container maxWidth="lg">
                    <Paper elevation={3} sx={{ p: 4 }}>
                        <Grid container spacing={4}>
                            <Grid item xs={12} md={6}>
                                <Typography variant="h4" gutterBottom color="primary">
                                    Crear Nueva Empresa
                                </Typography>
                                <form onSubmit={handleSubmit}>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12}>
                                            <TextField
                                                fullWidth
                                                label="Nombre de la Empresa"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                required
                                                InputProps={{
                                                    startAdornment: <Business sx={{ mr: 1, color: 'action.active' }} />,
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                fullWidth
                                                label="Nit"
                                                name="nit"
                                                value={formData.nit}
                                                onChange={handleChange}
                                                required
                                                InputProps={{
                                                    startAdornment: <NumbersIcon sx={{ mr: 1, color: 'action.active' }} />,
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                fullWidth
                                                label="Dirección"
                                                name="address"
                                                value={formData.address}
                                                onChange={handleChange}
                                                required
                                                InputProps={{
                                                    startAdornment: <HomeIcon sx={{ mr: 1, color: 'action.active' }} />,
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                fullWidth
                                                label="Teléfono"
                                                name="phone"
                                                value={formData.phone}
                                                onChange={handleChange}
                                                required
                                                InputProps={{
                                                    startAdornment: <Phone sx={{ mr: 1, color: 'action.active' }} />,
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                fullWidth
                                                label="Sitio Web"
                                                name="website"
                                                value={formData.website}
                                                onChange={handleChange}
                                                InputProps={{
                                                    startAdornment: <Language sx={{ mr: 1, color: 'action.active' }} />,
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                fullWidth
                                                label="Correo Electrónico"
                                                name="email"
                                                type="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                required
                                                InputProps={{
                                                    startAdornment: <Email sx={{ mr: 1, color: 'action.active' }} />,
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                fullWidth
                                                label="Descripción"
                                                name="description"
                                                value={formData.description}
                                                onChange={handleChange}
                                                multiline
                                                rows={4}
                                                InputProps={{
                                                    startAdornment: <Description sx={{ mr: 1, mt: 1, color: 'action.active' }} />,
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography variant="subtitle1" gutterBottom>
                                                Color de la Empresa
                                            </Typography>
                                            <ColorPicker color={formData.color} onChange={handleColorChange} />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Input
                                                fullWidth
                                                required
                                                type="file"
                                                id="formFile"
                                                aria-describedby="my-helper-text"
                                                onChange={(e) => {
                                                    convertImagen(e);
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Button
                                                type="submit"
                                                variant="contained"
                                                color="primary"
                                                fullWidth
                                                size="large"
                                            >
                                                Crear Empresa
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </form>
                            </Grid>
                            <Grid item xs={12} md={6} sx={{ display: { xs: 'none', md: 'block' } }}>
                                <Box
                                    sx={{
                                        height: '100%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        textAlign: 'center',
                                    }}
                                >
                                    <Typography variant="h3" gutterBottom color="primary">
                                        Bienvenido a tu nueva aventura empresarial
                                    </Typography>
                                    <Box color="#FF00FF">
                                        <Typography variant="h6" paragraph background={formData.color} color="#FFFFFF">
                                            Comienza tu viaje creando el perfil de tu empresa hoy mismo.
                                        </Typography>
                                    </Box>
                                    <Typography variant="h6" paragraph color="text.secondary">
                                        Comienza tu viaje creando el perfil de tu empresa hoy mismo.
                                    </Typography>
                                    <Box
                                        component="img"
                                        src={`data:image/jpeg;base64,${file}`}
                                        alt="Business illustration"
                                        sx={{ maxWidth: '100%', height: 'auto' }}
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                    </Paper>
                </Container>
            </Box>
        </ThemeProvider>
    );
}
